import { ICellRendererParams } from "ag-grid-community";
import styles from "components/app/AccountNameRenderer.module.scss";
import useFilterModelHighlightHTML from "components/app/useFilterModelHighlightHTML";
import { FlagEnum, isFlag } from "components/portfolio/utils";
import Link from "next/link";
import { FC } from "react";
import { Account } from "types/portfolio";
import { classHOC } from "./ClassWrapper";

const AccountNameRenderer: FC<
  Partial<ICellRendererParams> & {
    paramsApi?: any;
    paramsData?: any;
    openNew?: boolean;
  }
> = ({ api, data, paramsApi, paramsData, openNew = false }) => {
  const comonApi = api ?? paramsApi;
  const comonData = data ?? paramsData;
  const markConfig: Array<{
    id: string;
    label: string;
    enable: (data: Account) => boolean;
  }> = [
    {
      id: "swssEnhanced",
      label: "SWSS-Enhanced",
      enable: (data) => data?.swssAccountTypeIndicator === "enhanced",
    },
    {
      id: "swssPremium",
      label: "SWSS-Premium",
      enable: (data) => data?.swssAccountTypeIndicator === "premium",
    },
    {
      id: "concierge",
      label: "Concierge",
      enable: (data) => data?.conciergeStatus === "Active",
    },
    {
      id: "suit",
      label: "Webex Suite",
      enable: (data) => data?.webexSuiteFlag,
    },
    {
      id: "cgem",
      label: "CGEM",
      enable: (data) => data?.cgemFlag === "Y",
    },
    {
      id: "wholesalepartner",
      label: "Wholesale Partner",
      enable: (data) => data?.wholesaleFlag,
    },
    {
      id: "littleFish",
      label: "Little Fish",
      enable: (data) => isFlag(data?.bannerFlag, FlagEnum.LittleFish),
    },
    {
      id: "bigFish",
      label: "Big Fish",
      enable: (data) => isFlag(data?.bannerFlag, FlagEnum.BigFish),
    },
    {
      id: "wpaFlag",
      label: "WPA",
      enable: (data) => isFlag(data?.bannerFlag, FlagEnum.WpaFlag),
    },
  ];
  const enabledConfig = markConfig.filter((c) => c.enable(comonData));

  return (
    <div>
      <Link
        passHref={true}
        href={`/spng/summary?accountId=${comonData?.accountId}`}
        legacyBehavior
      >
        <a
          className={styles.link}
          target={openNew ? "_blank" : "_top"}
          style={{ marginLeft: 14 }}
        >
          <span
            style={{ fontSize: "inherit" }}
            dangerouslySetInnerHTML={{
              __html: useFilterModelHighlightHTML(comonApi, comonData?.accountName),
            }}
          />
        </a>
      </Link>
      {enabledConfig.length > 0 && (
        <div style={{ display: "flex" }}>
          {enabledConfig.map((x, i) => {
            const width = 90 / (enabledConfig.length || 1);
            const left = 10 + width * i;

            return (
              <span
                key={x.id}
                className={`${styles.newMarker} ${styles[x.id]}`}
                style={{
                  width: width + "%",
                  left: left + "%",
                }}
              >
                {x.label}
              </span>
            );
          })}
        </div>
      )}
      {comonData?.priorityIndicatorRank && comonData?.priorityIndicatorRank <= 150 ? (
        <div className={styles.ribbonWrap}>
          <div className={`${styles.ribbonLabel} ${styles.colorGreen}`}>
            {comonData.priorityIndicatorRank} of 150
          </div>
        </div>
      ) : comonData?.priorityIndicatorRank &&
        comonData?.priorityIndicatorRank <= 500 &&
        comonData?.priorityIndicatorRank > 150 ? (
        <div className={styles.ribbonWrap}>
          <div className={`${styles.ribbonLabel} ${styles.colorBlue}`}>
            {comonData.priorityIndicatorRank} of 500
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default classHOC(AccountNameRenderer);
